import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { FabricanteRequest, Response } from './Types';
class FabricanteController {
  public static async Listar(request: FabricanteRequest): Promise<Response> {
    try {
      console.log('Controller Fabricante Listar');
      console.log(request);

      const response = await Api.post('api/fabricante/Listar', request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(FabricanteId: number): Promise<Response> {
    try {
      console.log('Controller Fabricante Listar Unico');
      console.log(FabricanteId);

      const response = await Api.get(
        `api/fabricante/ListarUnico/${FabricanteId}`
      );

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(request: FabricanteRequest): Promise<Response> {
    try {
      console.log('Controller Fabricante Adicionar');
      console.log(request);

      const response = await Api.post(`api/fabricante/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(request: FabricanteRequest): Promise<Response> {
    try {
      console.log('Controller Fabricante Atualizar');
      console.log(request);

      const response = await Api.put(`api/fabricante/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: FabricanteRequest): Promise<Response> {
    try {
      console.log('Controller Fabricante Excluir');
      console.log(request);

      const response = await Api.put(`api/fabricante/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default FabricanteController;
